import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "release-safe-area" }, null, -1)),
          _withDirectives(_createVNode(_component_ion_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnBack())),
            class: _normalizeClass(['header-sm-button', 'bg-transparent', 'top-level', !_ctx.isReleaseGuide ? 'white-regular' : ''])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "end",
                icon: _ctx.closeOutline
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["class"]), [
            [_vShow, !_ctx.isLandscapeMode]
          ]),
          _withDirectives(_createVNode(_component_ion_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnBack('Programs'))),
            class: "header-sm-button bg-transparent top-level white-regular"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "end",
                icon: _ctx.chevronDown
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.isLandscapeMode && _ctx.isMobile]
          ]),
          _withDirectives(_createVNode(_component_ion_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFullscreenMode(true))),
            class: "header-sm-button header-sm-button-right top-level bg-transparent white-regular"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "end",
                icon: _ctx.resize
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.isReleaseVideo && !_ctx.isLandscapeMode && _ctx.isMobile]
          ]),
          _createVNode(_component_ion_router_outlet, { id: "release-router" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}